import React from 'react';
import {
    Heading,
    Image,
} from 'reaxl';
import _capitalize from 'lodash/capitalize';
import BrowseByBudgetForm from '@/component/BrowseByBudgetForm';

const BrowseByBudgetContainer = React.memo(({ heading = '', code = 'new', additionalClasses = '', withPixallData = true }) => ((
    <div
        id="browseByBudgetModuleSection"
        className={`search-by-budget-container container colored-background inverted bg-primary padding-vertical-4 padding-vertical-md-5 margin-0 ${additionalClasses}`}
    >
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12 col-md-10 col-md-offset-1">
                    <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-0 col-lg-5">
                        <Heading
                            className="margin-bottom-1 padding-left-0"
                            componentClass="h2"
                            size={700}
                            role="heading"
                            aria-level={2}
                        >
                            {heading || `${_capitalize(code)} Cars by Price`}
                        </Heading>
                        <BrowseByBudgetForm
                            withPixallData={withPixallData}
                        />
                    </div>
                    <div
                        className="display-none display-md-flex justify-content-center col-md-6 col-lg-7 padding-right-0"
                        style={{ height: '154px' }}
                    >
                        <div
                            className="align-self-center"
                            style={{
                                maxHeight: '135px',
                                maxWidth: '527px',
                            }}
                        >
                            <Image
                                src="https://atc-cms-dam.s3.amazonaws.com/content/dam/autotrader/search-by-budget.png"
                                alt={`${code} car by price`}
                                style={{
                                    height: '100%',
                                    width: '100%',
                                }}
                                lazyload={false} // image is above fold, is only on desktop
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)));

export default BrowseByBudgetContainer;
